const buildTempId = (() => {
  let counter = 0;
  return () => `temp-ciclo-${counter++}`;
})();

const ESTADOS_VALIDOS = new Set(["planificado", "activo", "cerrado", "cancelado"]);

const toDateInputValue = (value) => {
  if (!value) return "";
  if (typeof value === "string") {
    const [datePart] = value.split("T");
    if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) return datePart;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value || "";
  return date.toISOString().split("T")[0];
};

const normalizeCentroLabel = (ciclo = {}) => {
  const alias = ciclo.centro_alias || ciclo.centroAlias || "";
  const nombre = ciclo.centro_nombre || ciclo.centroNombre || "";
  return alias || nombre || "";
};

export const normalizeCiclo = (ciclo = {}, fallbackId) => {
  const fechaInicioRaw = ciclo.fecha_inicio ?? ciclo.fechaInicio ?? "";
  const fechaFinRaw = ciclo.fecha_fin ?? ciclo.fechaFin ?? "";
  const centroId = ciclo.centro_id ?? ciclo.centroId ?? "";
  const anio = ciclo.anio ?? ciclo.year ?? "";
  const plantillaId = ciclo.plantilla_id ?? ciclo.plantillaId ?? "";
  const cursoIds = Array.isArray(ciclo.cursos)
    ? ciclo.cursos.map((c) => c.curso_id ?? c.id).filter(Boolean)
    : Array.isArray(ciclo.curso_ids)
    ? ciclo.curso_ids
    : [];

  return {
    id: ciclo.id ?? fallbackId ?? buildTempId(),
    centroId,
    centroLabel: normalizeCentroLabel(ciclo),
    plantillaId,
    plantillaNombre: ciclo.plantilla_nombre || ciclo.plantillaNombre || "",
    anio,
    codigo: ciclo.codigo?.trim() || "SIN-CODIGO",
    nombre: ciclo.nombre?.trim() || "Sin nombre",
    fechaInicio: toDateInputValue(fechaInicioRaw),
    fechaFin: toDateInputValue(fechaFinRaw),
    estado: ciclo.estado || "planificado",
    observaciones: ciclo.observaciones?.trim() || "",
    activo:
      typeof ciclo.activo === "boolean"
        ? ciclo.activo
        : ciclo.activo === 1 || ciclo.activo === "1",
    cursoIds,
    createdAt: ciclo.created_at || ciclo.createdAt || null,
    updatedAt: ciclo.updated_at || ciclo.updatedAt || null,
  };
};

export const initialFormState = {
  centro_id: "",
  plantilla_id: "",
  anio: "",
  codigo: "",
  nombre: "",
  fecha_inicio: "",
  fecha_fin: "",
  estado: "planificado",
  observaciones: "",
  activo: true,
  curso_ids: [],
};

export const buildPayload = (form) => ({
  centro_id: form.centro_id || null,
  plantilla_id: form.plantilla_id ? Number(form.plantilla_id) : null,
  anio: form.fecha_inicio ? new Date(form.fecha_inicio).getFullYear() : (form.anio ? Number(form.anio) : null),
  codigo: form.codigo?.trim() || "",
  nombre: form.nombre?.trim() || "",
  fecha_inicio: form.fecha_inicio || null,
  fecha_fin: form.fecha_fin || null,
  estado: form.estado || "planificado",
  observaciones: form.observaciones?.trim() || null,
  activo: form.activo ? 1 : 0,
  curso_ids: Array.isArray(form.curso_ids) ? form.curso_ids.map(Number).filter(Boolean) : [],
});

export const validarCiclo = (form) => {
  if (!form.centro_id) return "El centro es obligatorio.";
  if (!form.fecha_inicio) return "La fecha de inicio es obligatoria.";
  if (!form.codigo?.trim()) return "El codigo del ciclo es obligatorio.";
  if (!form.nombre?.trim()) return "El nombre del ciclo es obligatorio.";
  if (form.estado && !ESTADOS_VALIDOS.has(form.estado)) {
    return "El estado del ciclo es invalido.";
  }
  if (form.fecha_inicio && form.fecha_fin) {
    const ini = new Date(form.fecha_inicio);
    const fin = new Date(form.fecha_fin);
    if (!Number.isNaN(ini.getTime()) && !Number.isNaN(fin.getTime()) && fin < ini) {
      return "La fecha de fin no puede ser anterior a la fecha de inicio.";
    }
  }
  return null;
};

export const extractCiclo = (response, fallback) => {
  const base = response?.ciclo ?? response ?? {};
  const merged = fallback ? { ...fallback, ...base } : base;
  return normalizeCiclo(merged);
};
